export enum LoadingState {
	LOADING = 'LOADING',
	LOADED = 'LOADED',
	ERROR = 'ERROR',
}

export type EmptyStateProps = {
	image: {
		path: string;
		alt: string;
	};
	headline: string;
	description: string;
	callToAction?: {
		label: string;
		ariaLabel: string;
		dataLinkEvent: string;
		ctaCallback?: () => void;
		className?: string;
	};
};

export type NetworkErrorConfig = Required<EmptyStateProps>;

export type NoResultConfig = Omit<EmptyStateProps, 'callToAction'>;

export type NoResultConfigViaCta = Required<EmptyStateProps>;
